function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
export default function mergeExpectedErrors(fromDataConfig, graphQlOpertion) {
    const fromDataConfigStrings = fromDataConfig.filter((error)=>typeof error === 'string');
    if (graphQlOpertion.type === 'STANDALONE_QUERY' || graphQlOpertion.type === 'MUTATION') {
        const merged = [
            ...graphQlOpertion.expectedErrors,
            ...fromDataConfigStrings
        ];
        const uniqueErrors = [
            ...new Set(merged)
        ];
        return _object_spread_props(_object_spread({}, graphQlOpertion), {
            expectedErrors: uniqueErrors
        });
    }
    const expErrorsFromCallSite = graphQlOpertion.expectedErrors;
    const mergedExpectedErrors = {};
    for (const [prefix, fromCallSitePrefixErrors] of Object.entries(expErrorsFromCallSite)){
        const merged = [
            ...fromCallSitePrefixErrors,
            ...fromDataConfigStrings
        ];
        const uniqueErrors = [
            ...new Set(merged)
        ];
        mergedExpectedErrors[prefix] = uniqueErrors;
    }
    return _object_spread_props(_object_spread({}, graphQlOpertion), {
        expectedErrors: mergedExpectedErrors
    });
}

//# sourceMappingURL=mergeExpectedErrors.js.map